if (!customElements.get('show-more')) {
  customElements.define('show-more', class ShowMore extends HTMLElement {
    constructor() {
      super()
      // bindings
      this.onShowMore = this.onShowMore.bind(this)

      // elements
      this.button = this.querySelector('button')

      // listeners
      if(this.button)
        this.button.addEventListener('click', this.onShowMore)
    }

    onShowMore() {
      const isDesktop = window.innerWidth > 768
      const content = this.querySelectorAll('.show-more-content.tw-hidden')

      var columnCount = isDesktop ? 3 : 2
      if(isDesktop && content[0].dataset.index == 3)
        columnCount = 4

      if(content.length - columnCount <= 1) this.button.remove()

      for (let i = 0; i < columnCount; i++)
        content[i]?.classList.remove('tw-hidden')
    }
  })
}